import { Link } from "react-router-dom";
import { BrandLogo } from "../../app/BrandLogo";
import { Icon } from "../../app/Icon";

const socialLinks = [
  ["TikTok", "https://www.tiktok.com/@stencilmakerai"],
  ["YouTube", "https://www.youtube.com/@StencilMakerAI"],
  ["Facebook", "https://www.facebook.com/profile.php?id=61594861794898"],
  ["LinkedIn", "https://www.linkedin.com/company/stencil-maker-ai/home/?viewAsMember=true"],
] as const;

export function LandingFooter({ homeSections = false }: { homeSections?: boolean }) {
  const sectionHref = (id: string) => `${homeSections ? "/" : ""}#${id}`;
  return <footer className="landing-footer">
    <div className="landing-footer__inner landing-wrap">
      <div className="landing-footer__brand">
        <Link className="landing-brand" to="/" aria-label="Stencil Studio home"><BrandLogo /></Link>
        <p className="landing-footer__statement">Less tracing.<br /><em>More tattooing.</em></p>
        <span>From your first reference to the final stencil. Create, refine, and make it yours.</span>
      </div>

      <div className="landing-footer__links">
        <nav aria-labelledby="footer-product-heading">
          <p id="footer-product-heading">Product</p>
          <a href={sectionHref("how-it-works")}>How it works</a>
          <a href={sectionHref("results")}>Results</a>
          <a href={sectionHref("pricing")}>Pricing</a>
          <Link to="/blog">Blog</Link>
        </nav>
        <nav aria-labelledby="footer-account-heading">
          <p id="footer-account-heading">Account</p>
          <Link to="/ai">Open the studio</Link>
          <Link to="/sign-in">Sign in</Link>
        </nav>
        <nav aria-labelledby="footer-legal-heading">
          <p id="footer-legal-heading">Legal</p>
          <Link to="/terms">Terms &amp; Conditions</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/refund-policy">Refund Policy</Link>
        </nav>
        <nav aria-labelledby="footer-social-heading">
          <p id="footer-social-heading">Follow</p>
          {socialLinks.map(([label, href]) => <a className="landing-footer__social" key={label} href={href} target="_blank" rel="noreferrer"><span>{label}<span className="landing-sr-only"> (opens in a new tab)</span></span><Icon name="arrow-right" /></a>)}
        </nav>
      </div>

      <div className="landing-footer__bottom">
        <p>© {new Date().getFullYear()} Stencil Studio</p>
        <span className="landing-footer__signature">Your artwork. Your workflow.</span>
        <a href={homeSections ? "/" : "#landing-main"}>Back to {homeSections ? "home" : "top"}<span className="landing-footer__back-icon"><Icon name={homeSections ? "arrow-right" : "arrow-up"} /></span></a>
      </div>
    </div>
  </footer>;
}
